export const buildShippingMethodStr = (carrierCd: string) => (methodCd: string): string => carrierCd.concat('_').concat(methodCd);